import { useState } from 'react';
import { Dropdown } from '@shared/ui/Dropdown';
import { isLocalPreview, localPreviewRole } from '@shared/lib/localPreview';
import { isMiniAppLayout, MINI_APP_PREVIEW_SURFACE_KEY } from '@shared/lib/miniAppLayout';
import styles from './LocalPreviewBar.module.css';

export function LocalPreviewBar() {
  const [layoutError, setLayoutError] = useState('');
  if (!isLocalPreview()) return null;
  return <aside className={styles.bar} aria-label="Local preview controls">
    <span><strong>Local preview</strong><small>Sample data · No real payments</small></span>
    <div className={styles.controls}>
      <label>View as <Dropdown size="compact" variant="normal" aria-label="Preview account" value={localPreviewRole()} onValueChange={(event) => {
        localStorage.setItem('dev:previewRole', event);
        window.location.reload();
      }}><option value="admin">Admin</option><option value="seller">My seller</option><option value="demo">Demo shop</option><option value="guest">Browser sign-in</option></Dropdown></label>
      <label>Layout <Dropdown size="compact" variant="normal" aria-label="Preview layout" value={isMiniAppLayout() ? 'telegram' : 'website'} onValueChange={(surface) => {
        try {
          localStorage.setItem(MINI_APP_PREVIEW_SURFACE_KEY, surface);
          window.location.reload();
        } catch {
          setLayoutError('Enable browser storage to change the preview layout.');
        }
      }}><option value="website">Website</option><option value="telegram">Telegram Mini App</option></Dropdown></label>
      {layoutError ? <small className={styles.error} role="alert">{layoutError}</small> : null}
    </div>
  </aside>;
}
